"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineCookieService = void 0;
const v1_1 = require("./v1");
__exportStar(require("./v1/types"), exports);
__exportStar(require("./consent-manager"), exports);
const optionalFeatureServices = {
    's2:server-request': '^1.0.0',
    's2:serialized-state-manager': '^1.0.0',
};
function defineCookieService(options) {
    return {
        id: 'cookie-service',
        optionalDependencies: {
            featureServices: optionalFeatureServices,
        },
        create: (env) => {
            const serverRequest = env.featureServices['s2:server-request'];
            const serializedStateManager = env.featureServices['s2:serialized-state-manager'];
            const v1 = new v1_1.CookieServiceV1Impl(options.consentManager, serverRequest && serverRequest.cookies, serializedStateManager);
            if (options.cookiesToRegister) {
                v1.registerCookies(options.cookiesToRegister);
            }
            return {
                '1.1.0': () => ({
                    featureService: v1,
                }),
            };
        },
    };
}
exports.defineCookieService = defineCookieService;
//# sourceMappingURL=index.js.map